/**
 * @file   src\components\Common\RangeSlider.js
 * @brief  This file is responsible for price slider
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";

const RangeSliderComponent = (props) => {
  const {
    min,
    max,
    value,
    onInput,
    defaultValue,
    onThumbDragStart,
    onThumbDragEnd,
    sliderClass,
    stepValue = 0,
    rangeSlideDisabled,
    thumbsDisabled,
  } = props;
  return (
    <RangeSlider
      className={sliderClass}
      min={min}
      max={max}
      value={value}
      onInput={onInput}
      step={stepValue}
      defaultValue={defaultValue}
      onThumbDragStart={onThumbDragStart}
      onThumbDragEnd={onThumbDragEnd}
      thumbsDisabled={thumbsDisabled}
      rangeSlideDisabled={rangeSlideDisabled}
    />
  );
};
export default RangeSliderComponent;
